import React from "react";
import { MailIcon, MapPinIcon, NewspaperIcon } from "lucide-react";
import { PageShell } from "../components/PageShell";
import { ContactForm } from "../components/contact/ContactForm";
import { images } from "../data/site";
const contacts = [{
  icon: MailIcon,
  label: "E-mail",
  value: "contact@mieussy2028.fr",
  href: "mailto:contact@mieussy2028.fr"
}, {
  icon: NewspaperIcon,
  label: "Presse",
  value: "presse@mieussy2028.fr",
  href: "mailto:presse@mieussy2028.fr"
}, {
  icon: MapPinIcon,
  label: "Adresse",
  value: "Association Mieussy 2028, 74440 Mieussy, Haute-Savoie"
}];
export function Contact() {
  return <PageShell title={<>Écrivez-<span className="italic" data-id="element-229" data-mp="17slhwfwbt4wt">nous</span></>} intro="Une question sur l'événement, la presse, un partenariat ou des archives de 1978 à partager ? L'équipe vous répond." image={images.pertuiset} imageAlt="Le décollage du Pertuiset au-dessus de la vallée" data-id="element-228" data-mp="17racycr59r44">
      <section className="mx-auto grid max-w-[1320px] gap-12 px-5 py-24 md:px-10 md:py-28 lg:grid-cols-12 lg:gap-16" data-id="element-230" data-mp="aalduqtkx2yf">
        <div className="lg:col-span-4" data-id="element-231" data-mp="15dch3lgoww65">
          <ul className="divide-y divide-navy/15 border-y border-navy/15" data-id="element-232" data-mp="19gih4bd7lr46">
            {contacts.map(({
            icon: Icon,
            label,
            value,
            href
          }) => <li key={label} className="flex gap-4 py-6" data-id="element-233" data-mp="1e8ioupzitobb">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-red" aria-hidden="true" data-id="element-234" data-mp="1j73e5ud8inkz" />
                <div data-id="element-235" data-mp="mh2si485wn7w">
                  <p className="text-sm text-navy-soft" data-id="element-236" data-mp="mhmblo9jthni">{label}</p>
                  {href ? <a href={href} className="font-medium hover:text-red" data-id="element-237" data-mp="qhmov5kwvmsz">{value}</a> : <p className="font-medium" data-id="element-238" data-mp="qjzhccoapfka">{value}</p>}
                </div>
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-2xl leading-snug" data-id="element-239" data-mp="10g2jvjn27g7r">
            Vous avez des photos ou des souvenirs du <span className="italic text-red" data-id="element-240" data-mp="26wxpg7hwo434">25 juin 1978</span> ? Ils nous intéressent.
          </p>
        </div>
        <div className="lg:col-span-8" data-id="element-241" data-mp="2bupqbr0j30jg">
          <ContactForm data-id="element-242" data-mp="2bxlrrpbl47cn" />
        </div>
      </section>
    </PageShell>;
}